export default "__VITE_ASSET__lMEPYomw__"